(function () {
  function initSection(section) {
    var variantInput = section.querySelector('.pp-variant-id');
    var quantityInput = section.querySelector('.pp-quantity');
    var tiers = Array.prototype.slice.call(section.querySelectorAll('.pp-tier'));
    var radios = Array.prototype.slice.call(section.querySelectorAll('.pp-tier__radio'));
    var atcPriceEls = Array.prototype.slice.call(section.querySelectorAll('[data-atc-price]'));
    var stickyPriceEls = Array.prototype.slice.call(section.querySelectorAll('[data-sticky-price]'));

    function syncPrice(price) {
      atcPriceEls.forEach(function (el) { el.textContent = price || ''; });
      stickyPriceEls.forEach(function (el) { el.textContent = price || ''; });
    }

    function selectRadio(radio) {
      if (!radio) return;
      radios.forEach(function (r) {
        var tier = r.closest('.pp-tier');
        if (tier) tier.classList.toggle('is-selected', r === radio);
      });
      radio.checked = true;
      if (variantInput && radio.value) variantInput.value = radio.value;
      if (quantityInput) quantityInput.value = radio.getAttribute('data-quantity') || '1';
      syncPrice(radio.getAttribute('data-price'));
    }

    radios.forEach(function (radio) {
      radio.addEventListener('change', function () { selectRadio(radio); });
    });

    tiers.forEach(function (tier) {
      tier.addEventListener('click', function (e) {
        if (e.target.matches('a')) return;
        var radio = tier.querySelector('.pp-tier__radio');
        selectRadio(radio);
      });
    });

    // Initialise from the checked radio (or first)
    var initial = radios.filter(function (r) { return r.checked; })[0] || radios[0];
    selectRadio(initial);

    // ---- Media gallery swap ----
    var mainImg = section.querySelector('.pp-media__img');
    var thumbs = Array.prototype.slice.call(section.querySelectorAll('.pp-media__thumb'));
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (!mainImg) return;
        mainImg.src = thumb.getAttribute('data-full');
        mainImg.alt = thumb.getAttribute('data-alt') || '';
        thumbs.forEach(function (t) { t.classList.toggle('is-active', t === thumb); });
      });
    });

    // ---- Sticky add-to-cart bar (mobile + desktop) ----
    var sticky = section.querySelector('[data-pp-sticky]');
    var atcBtn = section.querySelector('.pp-atc__btn');
    var stickyAdd = section.querySelector('[data-sticky-add]');

    if (sticky && atcBtn) {
      sticky.hidden = false;
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            // Only reveal once the buy box has been scrolled PAST (i.e. it has
            // left the viewport upwards). While it is still below the fold the
            // bar stays hidden.
            var scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            sticky.classList.toggle('is-visible', scrolledPast);
          });
        },
        { threshold: 0 }
      );
      observer.observe(atcBtn);

      if (stickyAdd) {
        stickyAdd.addEventListener('click', function () { atcBtn.click(); });
      }
    }
  }

  function init() {
    document.querySelectorAll('.pp-pdp, .pp-final').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init in Shopify theme editor when the section is reloaded
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector ? e.target.querySelector('.pp-pdp, .pp-final') : null;
    if (section) initSection(section);
  });
})();
